export default "__VITE_ASSET__CoUAzMNK__"